import { useEffect, useState } from 'react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';
import { generatePath, Link, useLocation, useNavigate } from 'react-router-dom-v5-compat';

import config from '@/config';
import type { ShareDetails } from '@/modules/api/codegen';
import type { Secret } from '@/modules/secrets/types';
import { Logo, Alert as UIAlert } from '@/modules/ui';

import * as felaRules from './SharedSecret.rules';
import { SharedSecretDetail } from './SharedSecretDetail';

export interface SharedSecretProps {
    secret: Secret;
    shareDetails?: ShareDetails;
}

export const SharedSecret = ({ secret, shareDetails }: SharedSecretProps) => {
    const { css } = useFela();
    const { state, pathname } = useLocation();
    const navigate = useNavigate();

    const [showValidityRefreshedAlert, setShowValidityRefreshedAlert] = useState(false);

    useEffect(() => {
        if (state?.validityRefreshed) {
            setShowValidityRefreshedAlert(true);

            // Reset the router state
            navigate(pathname, { state: {}, replace: true });
        }
    }, [state?.validityRefreshed, pathname, navigate]);

    return (
        <div className={css(felaRules.container)}>
            <Logo customStyle={felaRules.logo} />
            <div className={css(felaRules.wrapper)}>
                {showValidityRefreshedAlert && (
                    <UIAlert
                        type='success'
                        message={<FormattedMessage id='sharedSecret.alert.refreshed.title' />}
                        action={
                            <Link to={generatePath(config.routes.secret, { id: secret.id })} className={css(felaRules.alertLink)}>
                                <FormattedMessage id='sharedSecret.alert.refreshed.button.secret' />
                            </Link>
                        }
                    />
                )}

                <SharedSecretDetail secret={secret} shareDetails={shareDetails} />
            </div>
        </div>
    );
};
